import { PRISMIC_ZONE_LAYOUT } from '@/app/constants/zone';
import type { GameViewModel } from '@/types/games/game-view-model';

type ResolveSwjTilePropsInput = {
    game: GameViewModel;
    layout: PRISMIC_ZONE_LAYOUT;
    isSiteWideJackpotEnabled: boolean;
    hideSwjTickers: boolean;
};

export type SwjTileProps = {
    showSwjVisuals: boolean;
    swjLabel: 'default' | 'small' | undefined;
};

/** Resolves SWJ ticker and border props shared by server and client game factories. */
export const resolveSwjTileProps = ({
    game,
    layout,
    isSiteWideJackpotEnabled,
    hideSwjTickers
}: ResolveSwjTilePropsInput): SwjTileProps => {
    const showSwjVisuals = game.isSiteWideJackpot && isSiteWideJackpotEnabled;
    const swjLabel: 'default' | 'small' | undefined =
        !hideSwjTickers && showSwjVisuals ? (layout !== PRISMIC_ZONE_LAYOUT.DEFAULT ? 'small' : 'default') : undefined;

    return { showSwjVisuals, swjLabel };
};
